import "./RestaurantList.css";
import ButtonFormat from "./restaurantBtn/ButtonFormat";

import allInOne from "../../data/allInOneData.json";

const RestaurantList = ({ serviceTypeChild }) => {
  return (
    <div className="restaurantlist-wrapper">
      {allInOne[serviceTypeChild].map((info) => {
        return <ButtonFormat key={info.id} restaurantInformation={info} />;
      })}
    </div>
  );
};

export default RestaurantList;
